<template>
    <div class="home">
        <div
            class="callout callout-captioned"
        >
            <div class="callout-body">
                <h1>Modern Arts Midtown</h1>
                <p>
                    Appointment recommended, walk ins welcome<br />
                    Tue—Sat | 11-6pm<br />
                    3615 Dodge St., Omaha
                </p>
            </div>
            <Slideshow :images="slides" />
        </div>
        <div
            class="callout callout-1-2"
            v-if="nowShowingEvent"
            @click="navigate('/events')"
        >
            <div class="callout-body">
                <h2>Now Showing</h2>
                <div class="events-now-showing">
                    <Event
                        :key="nowShowingEvent.nid"
                        :event="nowShowingEvent"
                    />
                </div>
            </div>
            <div
                class="callout-body callout-image"
                style="background-image: url(/all-about-the-art.jpg)"
            />
        </div>
        <div class="callout callout-2-1" @click="navigate('/collection')">
            <div class="callout-body">
                <h2>Artist Collection</h2>
                <p>Browse available artwork by individual artist</p>
            </div>
            <div class="callout-body">
                <ul class="artist-collection">
                    <li v-for="artist in artists" :key="artist.nid">
                        {{ artist.name }}
                    </li>
                </ul>
            </div>
        </div>
        <div class="callout callout-1-2" @click="navigate('/search')">
            <div class="callout-body">
                <h2>Search</h2>
                <p>
                    Use this page to search the entire collection by size price
                    and more
                </p>
            </div>
            <div
                class="callout-body callout-image"
                style="background-image: url(/search.jpg)"
            />
        </div>
        <div class="callout callout-2-1" @click="navigate('/favorites')">
            <div class="callout-body">
                <h2>Favorites</h2>
                <p>
                    Click the "star" icon to save your favorite works to this
                    page. Then save, print or share
                </p>
            </div>
            <div
                class="callout-body callout-image callout-image-contain"
                :style="`background-image: url(${require('@/assets/favorites.jpg')});`"
            />
        </div>
        <div class="callout callouts callout-1-1 callouts-nested-outer">
            <div class="callout-body" @click="navigate('/search?sortBy=recent')">
                <div class="callout callout-1-1">
                    <!-- todo sort by date -->
                    <div class="callout-body">
                        <h2>New Work</h2>
                    </div>
                    <div
                        class="callout-body callout-image"
                        :style="newWorkImg()"
                    />
                </div>
            </div>
            <div class="callout-body" @click="navigate('/contact')">
                <div class="callout callout-1-1">
                    <div class="callout-body">
                        <h2>Services and Contact</h2>
                    </div>
                    <div
                        class="callout-body callout-image callout-image-contain"
                        style="background-image: url(/contact.png)"
                    />
                </div>
            </div>
        </div>

        <Newsletter heading="Subscribe to our newsletter" />
    </div>
</template>

<script>
import ArtworkHelper from "@/mixins/PageHelper.js";
import Newsletter from '@/components/Newsletter.vue';
import Slideshow from '@/components/Slideshow.vue';

export default {
    components: { Newsletter, Slideshow },
    name: "Home",
    mixins: [ArtworkHelper],
    data() {
        return {
            slides: [...Array(10).keys()].map(i => require(`@/assets/home-slides/${i + 1}.jpg`))
        };
    },
    computed: {
        artists() {
            const vm = this;
            return [...vm.allArtists].sort((a, b) =>
                a.lname.toString().localeCompare(b.lname.toString())
            );
        },
    },
    methods: {
        newWorkImg() {
            const vm = this;
            if (! vm.allArtworks.length) return;
            const artwork = vm.newWork();
            return `background-image: url(${artwork.thumbnail}?${artwork.nid})`;
        },
        newWork() {
            const vm = this;
            const recent = [...vm.allArtworks].sort((a,b) => +a.nid - +b.nid)
                .slice(-20);

            return shuffle(recent)[0];
        }
    }
};

function shuffle(array) {
  let currentIndex = array.length,  randomIndex;

  // While there remain elements to shuffle...
  while (currentIndex != 0) {

    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }

  return array;
}
</script>

<style lang="scss">
</style>
